<div class="main-toolbar__title">{{ panelIndex }}. {{ panelTitle }}</div>
